var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"flex flex-col gap-[20px] text-[#333]"},[_c('div',{staticClass:"title font-semibold text-[24px] text-[#333]"},[_vm._v(" Dashboard ")]),_c('Invoice'),_c('Talent'),_c('Partner')],1)}
var staticRenderFns = []

export { render, staticRenderFns }